export default {
      id: "i-dash-circle-usage",
      viewBox: "0 0 126 122",
      url: __webpack_public_path__ + "img/sprite.svg#i-dash-circle",
      toString: function () {
        return this.url;
      }
    }